import React from "react";
import Benefits from "../components/landing/Benefits";
import CTA from "../components/landing/CTA";

function CompanyPage() {
    return (
        <>
            <section className="hero-section section-padding">
                <div className="w-layout-blockcontainer container w-container">
                    <div data-w-id="96d9ff61-25df-920c-9b60-fbbe7a6c4cfc"
                         className="content-wrapper company-hero">
                        <div className="section-title max-width">
                            <p className="label">about us</p>
                            <div className="title">
                                <h1 className="heading-1">Vision Statement</h1>
                                <p className="body-text-16">
                                    Our vision is to help businesses operate more efficiently by delivering intelligent
                                    mine infrastructure monitoring solutions powered by AI, real-time data, and cloud
                                    technology. We are committed to redefining safety and sustainability standards for
                                    tailings and mine residue facilities, enabling the mining industry to proactively
                                    manage risk, enhance operational performance, and strengthen long-term environmental
                                    and social resilience. Through continuous innovation and scalable solutions, we aim
                                    to set a new global benchmark for how critical mining assets are monitored and
                                    safeguarded.
                                </p>
                            </div>
                        </div>
                        <div className="company-hero-image-wrapper stoke">
                            <div className="company-hero-image">
                                <div className="future-image-wrapper-2">
                                    <img
                                        src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66debdcba27a9a8975c4ca5f_sphere%20(1).png"
                                        loading="lazy" alt="" className="future-image"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="hero-section section-padding mb-16">
                <div className="w-layout-blockcontainer container w-container">
                    <div data-w-id="96d9ff61-25df-920c-9b60-fbbe7a6c4cfc" className="content-wrapper company-hero">
                        <div className="max-width">
                            <div className="title">
                                <h1 className="heading-2">Born from Legacy, Driven by Purpose</h1>
                                <p className="body-text-16">
                                    In a world shaken by the devastating impact of tailings dam failures—from Brazil to
                                    Canada and beyond—the call for safer, smarter monitoring has never been louder.
                                    International institutions like the United Nations and the Global Industry Standard
                                    on Tailings Management (GISTM) have demanded a new era of responsibility,
                                    innovation,
                                    and transparency in how we manage mine waste.
                                </p>
                                <p className="body-text-16 mt-2">
                                    It was against this backdrop that three industry professionals in the consulting and
                                    mine operations space from the University of the Witwatersrand came together with a
                                    bold vision: to reimagine how we monitor the safety of tailings storage facilities.
                                    But their inspiration didn’t come from the headlines alone—it came from the legacy
                                    of
                                    one of South Africa’s most respected geotechnical minds: Professor Geoffrey Blight.
                                    A mentor, a pioneer, and a relentless problem-solver, Blight dedicated his life to
                                    the science of soil mechanics and the practical challenges of mine waste management.
                                    His work laid the foundation for understanding tailings behavior, seepage control,
                                    and the critical role of data in dam safety. His influence ran deep—not just in
                                    textbooks,
                                    but in the minds of those he taught, including us.
                                </p>
                                <p className="body-text-16 mt-2">
                                    Guided by his legacy, we developed a modern, AI-powered, cloud-based monitoring
                                    platform
                                    designed to transform tailings management from reactive to predictive. With
                                    real-time
                                    data from vibrating wire piezometers, standpipe readings, and other critical
                                    instruments,
                                    our system doesn’t just collect information—it understands it. It watches for
                                    anomalies,
                                    learns from patterns, and sends instant alerts when thresholds are crossed—giving
                                    teams
                                    time to act before it's too late. We believe tailings monitoring should be
                                    intelligent,
                                    accessible, and proactive. We believe in honoring the past by building a safer
                                    future.
                                    And we believe that with the right tools, data can save lives.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="hero-section section-padding mb-16">
                <div className="w-layout-blockcontainer container w-container">
                    <div data-w-id="96d9ff61-25df-920c-9b60-fbbe7a6c4cfc" className="content-wrapper company-hero">
                        <div className="max-width">
                            <div className="title">
                                <h1 className="heading-1">Product Dedication</h1>
                                <p className="body-text-16">
                                    But our true inspiration came from one of the greatest minds in geotechnical
                                    engineering:
                                    Professor Geoffrey Eustace Blight.
                                </p>
                                <p className="body-text-16 mt-2">
                                    Professor Blight devoted his life to understanding the complex behavior of mine
                                    waste,
                                    soils, and tailings—long before tailings safety became a global concern. His
                                    pioneering
                                    work laid the foundation for how tailings storage facilities are designed,
                                    monitored,
                                    and managed in South Africa and around the world
                                </p>
                                <p className="label">Geoffrey Eustace Blight (1934–2013)</p>
                                <p className="body-text-16 mt-2">
                                    Professor Geoffrey Eustace Blight was a highly respected civil engineer, academic,
                                    and researcher whose contributions to geotechnical engineering left an enduring
                                    impact
                                    on the global understanding of mine waste and tailings management. Born on 30 June
                                    1934
                                    in Pietersburg, South Africa, Blight attended Benoni High School and later graduated
                                    with a BSc in Civil Engineering from the University of the Witwatersrand (Wits) in
                                    1955.
                                </p>
                                <p className="body-text-16 mt-2">
                                    After a brief period at the consulting firm Kanthack and Partners, Blight returned
                                    to Wits to complete his MSc in 1958 under the supervision of Jere Jennings,
                                    focusing on the internal stability of filters. He was later awarded the prestigious
                                    Wits University Council Scholarship, which enabled him to pursue a PhD at Imperial
                                    College London. There, under the guidance of Professor Alan Bishop, Blight conducted
                                    pioneering research on the behavior of partially saturated soils—research that
                                    continues to inform numerical soil models today.
                                </p>
                                <p className="body-text-16 mt-2">
                                    Upon returning to South Africa, Blight spent two years at Wits before joining the
                                    National Building Research Institute in Pretoria. At the institute, he investigated
                                    problematic soils, including dolomites, heaving clays, and collapsible soils. In 1969,
                                    he returned to Wits, where he would spend much of his academic career. Though initially
                                    limited by his appointment, Blight expanded his research into pavements, alkali-aggregate
                                    reaction in concrete, municipal solid waste, and silo pressures, before focusing once
                                    again on his true passion: soil mechanics and its applications in mine tailings and
                                    industrial waste.
                                </p>
                                <p className="body-text-16 mt-2">
                                    Blight’s career was marked by his dual dedication to both academia and practical
                                    engineering. He consulted extensively for mining houses, contractors, and engineering
                                    firms, and he often credited the relevance of his research to its grounding in real-world
                                    engineering challenges. He held four Doctor of Science (DSc) degrees from the University
                                    of London, Wits, and the University of Cape Town, and received an honorary doctorate
                                    from Wits in 2009. emarkably, he completed his final textbook, Unsaturated Soil Mechanics
                                    in Geotechnical Practice, just days before his passing on 7 November 2013. He was married
                                    to Rhona and had three daughters and a son.
                                </p>
                                <p className="body-text-16 mt-2">
                                    Professor Blight’s contributions to tailings engineering were particularly impactful.
                                    His body of work included the authoritative Geotechnical Engineering for Mine Waste
                                    Storage Facilities, and he co-authored critical guidelines for the safe design and
                                    construction of mine waste systems, as published by the Chamber of Mines in South
                                    Africa. His research into the behavior of tailings significantly advanced industry
                                    practices and safety protocols, especially in the South African mining sector.
                                </p>
                                <p className="body-text-16 mt-2">
                                    Beyond tailings, Blight also influenced the development of landfill standards through
                                    his work on the Minimum Standards for Waste Disposal by Landfill, and contributed
                                    internationally through his involvement with the International Solid Waste Association.
                                    He was a key figure in the study of unsaturated and residual soils, and his work led
                                    to the publication of several texts including Mechanics of Residual Soils, co-edited
                                    with E.C. Leong.
                                </p>
                                <p className="body-text-16 mt-2">
                                    The importance of his research is commemorated through the “Blight Lecture,” delivered
                                    at the International Conference on Soil Mechanics and Geotechnical Engineering every
                                    four years.
                                </p>
                                <p className="body-text-16 mt-2">
                                    In addition to soil mechanics, Blight made notable contributions to material science
                                    and structural engineering. His research on concrete degradation culminated in the
                                    book Alkali-Aggregate Reaction and Structural Damage to Concrete, co-authored with
                                    Mark Alexander. His work on material handling and structural loads led to Assessing
                                    Loads on Silos and Other Bulk Storage Structures, further cementing his legacy as a
                                    multidisciplinary expert.
                                </p>
                                <p className="body-text-16 mt-2">
                                    Blight received numerous accolades throughout his career, including the J. James
                                    Croes Gold Medal from ASCE (1975), the Distinguished Research Award by SAICE (1989),
                                    the Telford Premium from ICE (1991), and the South African Geotechnical Gold Medal
                                    (1997). He was also the recipient of the 1997 Rankine Lecture, one of the highest
                                    honors in geotechnical engineering. His achievements earned him Honorary Fellow status
                                    at SAICE, Fellowship in the Royal Society of Southern Africa, and Life Membership
                                    with ASCE.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <CTA/>
        </>
    )
}

export default CompanyPage;